import api from "./api";

export const getsTerapiaPlanResumenViewPorTerapia = async (idTerapia) => {
    const response = await api.get("/TerapiaPlan/GetsTerapiaPlanResumenViewPorTerapia?idTerapia=" + (idTerapia == null ? 0 : idTerapia));

    return response.data.data;
}

export const getsTerapiaPlanResumenView = async (filters) => {
    const response = await api.get('/TerapiaPlan/GetsTerapiaPlanResumenView?'
            + 'idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&member=' + encodeURIComponent(filters.member == null ? "" : filters.member)
            + '&therapist=' + encodeURIComponent(filters.therapist == null ? "" : filters.therapist)
            + '&idEstadoVigencia=' + (filters.idEstadoVigencia == null ? "" : filters.idEstadoVigencia)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
            + '&idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
        );

    return response.data.data;
}

export const annulTerapiaPlan = (idTerapiaPlan) =>
    api.post("/TerapiaPlan/AnnulTerapiaPlan?idTerapiaPlan=" + idTerapiaPlan);

// Los objetivos del detalle del plan, tal como quedaron guardados. Se vuelven
// a leer al guardar para que las filas nuevas tomen su numero de fila del
// servidor: sin eso, el segundo guardado las enviaria con Id = 0 y se
// duplicarian.
export const getsTerapiaPlanObjetivoView = async (idTerapiaPlan) => {
    const response = await api.get("/TerapiaPlan/GetsTerapiaPlanObjetivoView?idTerapiaPlan=" + idTerapiaPlan);

    return response.data.data;
}

// Reporte de plan de terapia: una fila por area del plan y sesion de la
// terapia dentro de las fechas del plan.
export const getsReporteTrimestral = async (idTerapiaPlan) => {
    const response = await api.get("/TerapiaPlan/GetsReporteTrimestral?idTerapiaPlan="
        + (idTerapiaPlan == null ? 0 : idTerapiaPlan));

    return response.data.data;
}

export const getsTerapiaPlanAvanceView = async (idTerapiaPlan) => {
    const response = await api.get("/TerapiaPlan/GetsTerapiaPlanAvanceView?idTerapiaPlan="
            + (idTerapiaPlan == null ? 0 : idTerapiaPlan)
        );

    return response.data.data;
}

export const activeTerapiaPlan = (idTerapiaPlan) =>
    api.post("/TerapiaPlan/ActiveTerapiaPlan?idTerapiaPlan=" + idTerapiaPlan);

export const getTerapiaPlanView = async (idTerapiaPlan) => {
    const response = await api.get("/TerapiaPlan/GetTerapiaPlanView?idTerapiaPlan=" + idTerapiaPlan);

    return response.data.data;
}

export const addUpdateTerapiaPlanWithDetails = (dataPost) =>
    api.post("/TerapiaPlan/AddUpdateTerapiaPlanWithDetails", dataPost);
